import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateOutcomeRequest,
  LinkOutcomeRequest,
  OutcomeCard,
  OutcomeListPayload,
  OutcomeType,
  SaveOutcomeRequest,
} from './outcome-api.model';

export interface OutcomeApi {
  list(caseId: number): Observable<OutcomeListPayload>;
  listForClient(clientId: number): Observable<OutcomeListPayload>;
  get(caseId: number, outcomeId: number): Observable<OutcomeCard>;
  types(refresh?: boolean): Observable<readonly OutcomeType[]>;
  create(body: CreateOutcomeRequest): Observable<OutcomeCard>;
  update(outcomeId: number, body: SaveOutcomeRequest): Observable<OutcomeCard>;
  link(outcomeId: number, body: LinkOutcomeRequest): Observable<OutcomeCard>;
  unlink(outcomeId: number, body: LinkOutcomeRequest): Observable<OutcomeCard>;
  invalidate(outcomeId: number, reason: string): Observable<OutcomeCard>;
}
export const OUTCOME_API = new InjectionToken<OutcomeApi>('OUTCOME_API');
